import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Region, SBU } from '../../../../../models'
import { DataStore, Predicates, SortDirection } from "@aws-amplify/datastore";
import capitalizeFirst from "../../../../../components/common/capitalizeFirst";
import { ValidateHRRole } from '../../../../../components/helper/validateRole';
import LeftSideBar from '../../../../../components/common/hr/leftnav.component';
import TopNavBar from '../../../../../components/common/hr/topnav.component';
import { ConvertResponseForSelectWithRefCode } from '../../../../../components/helper/commonfunctions'
import Select from "react-select";
import HRLogin from "../../../../../setup/auth/hr.component";
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../components/helper/graphQLFunctions';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../../../graphql/mutations';
import * as queries from '../../../../../graphql/queries';

export default function CreateRegions() {
    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);
    const { regionid } = useParams();
    const [isEditMode, setEditMode] = useState(false);
    const [regionId, setRegionId] = useState("");
    let navigateTo = useNavigate();

    //Save Fields
    const [region, setRegion] = useState([]);

    const [sbuName, setSbuName] = useState([]);
    const [SbuList, setSbuList] = useState([]);
    const [SbuId, setSbuId] = useState("");
    const [refCode, SetRefCode] = useState("");




    //Create Record
    const saveRegion = async () => {
        if (region === "") { toast.error("Please enter Region."); return; }
        else if (SbuId === "") { toast.error("Please select SBU."); return; }

        setPleaseWaitButton(true);
        if (isEditMode) {
            // const original = await DataStore.query(Region, regionId);
            const original = await graphQLFindRecordById('getRegion', regionId);

            // await DataStore.save(
            //     Region.copyOf(original, (updated) => {
            //         updated.name = capitalizeFirst(region);
            //         updated.SBU_id = SbuId;
            //         updated.REF_CODE=refCode;
            //     })
            // );


            await API.graphql({
                query: mutations.updateRegion,
                variables: {
                    input: {
                        id: original.id,
                        name: capitalizeFirst(region),
                        SBU_id: SbuId,
                        REF_CODE: refCode,
                        _version: original._version,
                    }
                }
            });
            toast.success("Updated");
        } else {
            // await DataStore.save(new Region({ 
            //     name: capitalizeFirst(region), 
            //     SBU_id: SbuId, 
            //     REF_CODE: capitalizeFirst(refCode) 
            // }));
            await API.graphql(
                graphqlOperation(mutations.createRegion, {
                    input: {
                        name: capitalizeFirst(region),
                        SBU_id: SbuId,
                        REF_CODE: capitalizeFirst(refCode)
                    }
                })
            );
            toast.success('Added');
        }

        setPleaseWaitButton(false);
        navigateTo("/hr/setting/regions");
    };

    async function BindList() {
        // var SBUList = await DataStore.query(SBU, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });

        var SBUList = await graphQLGetAllData('listSBUS');
        var SBUList = SBUList.sort((a,b)=>a.name.localeCompare(b.name));

        var mySBUArray = []; mySBUArray = ConvertResponseForSelectWithRefCode(SBUList);
        setSbuList(mySBUArray)

    }

    async function onLoad() {
        try {
            if (!ValidateHRRole()) { userHasAuthenticated(false); }

            //Edit existing record
            if (regionid != null) {
                setRegionId(regionid);

                // const original = await DataStore.query(Region, regionid);
                 const original = await graphQLFindRecordById('getRegion', regionid);

                if (original != null) {
                    // const SBU_original = await DataStore.query(SBU, original.SBU_id);
                    const SBU_original = await graphQLFindRecordById('getSBU', original.SBU_id);

                    setSbuName({ label: SBU_original.name + " (" + SBU_original.REF_CODE + ")", value: SBU_original.id })
                    setSbuId(SBU_original.id)
                    setRegion(original.name);
                    setEditMode(true);
                    SetRefCode(original.REF_CODE);
                }
                else {
                    toast.error('Invalid record.');
                    navigateTo("/hr/setting/regions");
                }

            }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);

    return (
        isAuthenticated ? (
            <div>
                <div className="pt-16 xl:h-full lg:h-full md:h-full 2xl:h-full ">
                    <TopNavBar />
                    <LeftSideBar />

                    <div className="pl-16">
                        <div className="flex grid flex-row flex-wrap justify-center flex-1 gap-4 p-5 pl-5 pr-5 mt-5 align-center 2xl:grid-cols-8 xl:grid-cols-10 lg:grid-cols-8 md:grid-cols-8 sm:grid-cols-1 contract-grid-wrapper">
                            <div className="col-span-6 col-start-3 lg:col-start-3 xl:col-start-3 2xl:col-start-2">
                                <div className="p-3 py-5 bg-white rounded-md shadow dark:bg-[#252423]">
                                    <div className="flex justify-center mt-3 mb-2">
                                        <h2 className="page-title">
                                            {isEditMode ? "Edit" : "Create"} Cluster
                                        </h2>
                                    </div>
                                    <div x-data="{tab: 1}"></div>
                                    <div className={"block w-full"}>
                                        <div className="px-4" x-show="tab === 1">
                                            <div className="flex grid flex-row flex-wrap flex-1 mb-6 align-center 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-x-4">
                                                <div className="relative mb-4">
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]"
                                                    >
                                                        Cluster
                                                        <label
                                                            htmlFor=""
                                                            className="text-[#FF0000] text-[14px] font-medium"
                                                        >
                                                            *{" "}
                                                        </label>
                                                    </label>
                                                    <input
                                                        value={(region)}
                                                        onChange={(e) => setRegion(e.target.value)}
                                                        type="text"
                                                        id=""
                                                        className="text-[16px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"
                                                        placeholder="Enter  Cluster"
                                                    />
                                                </div>
                                                <div className="relative mb-4">
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]"
                                                    >
                                                        SBUs
                                                        <label
                                                            htmlFor=""
                                                            className="text-[#FF0000] text-[14px] font-medium"
                                                        >
                                                            *{" "}
                                                        </label>
                                                    </label>
                                                    <Select placeholder='Select' options={SbuList} value={sbuName} onChange={e => {
                                                        setSbuName(e)
                                                        setSbuId(e.value)
                                                    }} className="mt-2 my-react-select-container"
                                                        classNamePrefix="my-react-select" />
                                                </div>

                                                <div className="relative mb-4">
                                                    <label
                                                        htmlFor=""
                                                        className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]"
                                                    >
                                                        Ref_Code
                                                        <label
                                                            htmlFor=""
                                                            className="text-[#FF0000] text-[14px] font-medium"
                                                        >

                                                        </label>
                                                    </label>
                                                    <input
                                                        value={(refCode)}
                                                        onChange={(e) => SetRefCode(e.target.value)}
                                                        type="text"
                                                        id=""
                                                        className="text-[16px] rounded-lg  flex-1  border border-[#D0D5DD] w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"
                                                        placeholder="Ref Code"
                                                    />
                                                </div>

                                            </div>
                                            <div className="grow flex justify-center gap-3 mb-3">
                                                <Link
                                                    to="/hr/setting/regions"
                                                    className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:border-[#4A5056] dark:bg-[#4A5056] dark:text-white"
                                                >
                                                    Cancel
                                                </Link>
                                                <button
                                                    onClick={() => saveRegion()}
                                                    className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md"
                                                >
                                                    {showPleaseWaitButton ? "Please wait..." : "Submit"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <HRLogin sessionExpired={1} />
        )

    );
}